import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, Package, DollarSign, Store, History, PlusCircle, Upload, CheckCircle2 } from "lucide-react";
import { api, money } from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const numbers = [
    { key: "available_products", label: "Available Items", icon: Package, tone: "text-green-700" },
    { key: "reserved_products", label: "Awaiting Pickup (items)", icon: Store, tone: "text-teal-700" },
    { key: "active_orders", label: "Active Orders", icon: ShoppingBag, tone: "text-brick" },
    { key: "completed_sales", label: "Completed Sales", icon: CheckCircle2, tone: "text-navy" },
  ];

  const links = [
    { to: "/admin/inventory", label: "Available Products", icon: Package },
    { to: "/admin/orders", label: "Active Orders", icon: ShoppingBag },
    { to: "/admin/orders", label: "Order History", icon: History },
    { to: "/admin/inventory", label: "Sold / Reserved", icon: Store },
    { to: "/admin/products", label: "Add Product", icon: PlusCircle },
    { to: "/admin/import", label: "Import Products", icon: Upload },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-4xl text-navy">Dashboard</h1>
      <p className="text-ink/60 mt-1">Welcome back to JohnnyMart.</p>

      <div className="mt-8 grid gap-4 grid-cols-2 lg:grid-cols-4">
        {numbers.map((c) => (
          <div key={c.key} className="bg-white rounded-lg border border-navy/15 p-5">
            <c.icon className={`w-6 h-6 ${c.tone}`} />
            <div data-testid={`stat-${c.key}`} className="font-display text-3xl text-navy mt-2">{stats ? stats[c.key] : "—"}</div>
            <div className="text-sm text-ink/60 mt-1">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="mt-4 flex flex-wrap gap-4 text-sm text-ink/60">
        <span data-testid="stat-revenue">Paid revenue: <b className="text-navy">{stats ? money(stats.revenue) : "—"}</b></span>
        <span data-testid="stat-sold">Sold items: <b className="text-navy">{stats?.sold_products ?? "—"}</b></span>
        <span data-testid="stat-total-orders">All-time orders: <b className="text-navy">{stats?.total_orders ?? "—"}</b></span>
      </div>

      <div className="mt-8 grid gap-4 grid-cols-2 sm:grid-cols-3">
        {links.map((l) => (
          <Link key={l.label} to={l.to} data-testid={`dash-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="bg-navy text-cream rounded-lg p-5 hover:bg-brick transition-colors flex items-center gap-3">
            <l.icon className="w-6 h-6 text-gold shrink-0" />
            <span className="font-display text-lg leading-tight">{l.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
